import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { FINANCIACION_BANNER } from '../../data/brand';
const beneficios = ['Financiación de hasta el 100%', 'Tasa 0% en opciones seleccionadas', 'Asesoramiento personalizado', 'Toma de usado como parte de pago', 'Evaluación rápida, sin compromiso', 'Entregas claras, sin letra chica'];
export function FinanciacionSection() {
  return <Section id="financiacion" className="bg-surface" data-id="element-274" data-mp="1qcvxsj0gxfi5">
      <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-14" data-id="element-275" data-mp="1ce5zj01wx9s7">
        <Reveal data-id="element-276" data-mp="1cga3tj3q4at0">
          <div data-id="element-277" data-mp="1hd8s3l0phnja">
            <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white md:text-[42px]" data-id="element-278" data-mp="1hcqykw5fhnf2">
              0KM y financiación a tu medida
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-mist md:text-[17px]" data-id="element-279" data-mp="11d9btorste9">
              En VCARS te ayudamos a acceder a tu próximo vehículo 0km con opciones de
              financiación pensadas para adaptarse a tus posibilidades. Consultanos por
              planes disponibles, financiación de hasta el 100%, tasa 0% en opciones
              seleccionadas y entregas claras, sin letra chica.
            </p>

            <ul className="mt-7 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-280" data-mp="1j1uafwsi5s8a">
              {beneficios.map(b => <li key={b} className="flex items-start gap-2.5" data-id="element-281" data-mp="1x0tokaie2oq7">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-neon/15 text-neon" data-id="element-282" data-mp="1s31vhd60cwkf">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-283" data-mp="26ry173kldxhv" />
                  </span>
                  <span className="text-[14.5px] font-medium text-white" data-id="element-284" data-mp="21sbpwzobqrbp">{b}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap gap-3" data-id="element-285" data-mp="2fsmgs2pmw5wv">
              <ButtonLink to="/financiacion" size="lg" data-id="element-286" data-mp="2brax0dtfyewl">
                Consultar financiación
              </ButtonLink>
              <ButtonLink to="/catalogo?estado=0KM" variant="outline" size="lg" data-id="element-287" data-mp="2ivafxlsyuoen">
                Ver opciones 0KM
              </ButtonLink>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05} data-id="element-288" data-mp="2sr41tvskru93">
          <div className="overflow-hidden rounded-2xl border border-neon/40" style={{
          boxShadow: '0 0 40px -12px rgba(31,123,255,0.7)'
        }} data-id="element-289" data-mp="2squbu87j5n3e">
            <img src={FINANCIACION_BANNER} alt="VCARS 0KM con financiación tasa 0%: elegí tu marca y tu modelo entre Volkswagen, Chevrolet, Toyota, Fiat, Peugeot, Renault, Ford y Citroën" loading="lazy" className="w-full object-cover" data-id="element-290" data-mp="31jnsa8ypqsiu" />
          </div>
        </Reveal>
      </div>
    </Section>;
}